import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const enum PASSWORD_PATTERNS {
  LOWER_CASE = '(.*[a-z].*)',
  UPPER_CASE = '(.*[A-Z].*)',
  DIGITS = '(.*\\d.*)',
  SPECIALS = '[ `!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?~]',
  DIGITLETERSPACE_ = '^[a-zA-Z0-9 _]*$',
  VIN_ = '^[a-zA-Z0-9]*$',
  EMAIL = '^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+)*[a-zA-Z0-9]@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}$',
  MCDOT = '^[1-9]\\d{0,10}$',
}

export class FieldsValidation {
  static MatchFields(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: FormGroup) => {
      const control: AbstractControl = formGroup.controls[controlName];
      const matchingControl: AbstractControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return null;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
        return { mustMatch: true };
      } else {
        matchingControl.setErrors(null);
        return null;
      }
    };
  }

  static NotMatchFields(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: FormGroup) => {
      const control: AbstractControl = formGroup.controls[controlName];
      const matchingControl: AbstractControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustNotMatch']) {
        return null;
      }

      if (control.value === matchingControl.value) {
        matchingControl.setErrors({ mustNotMatch: true });
        return { mustNotMatch: true };
      } else {
        matchingControl.setErrors(null);
        return null;
      }
    };
  }

  static ContainUppercaseValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.UPPER_CASE).test(control.value)
      ? null
      : { needUpperCaseCharts: true };
  }

  static ContainLowercaseValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.LOWER_CASE).test(control.value)
      ? null
      : { needLowerCaseCharts: true };
  }

  static ContainDigitValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.DIGITS).test(control.value)
      ? null
      : { needDigitCharts: true };
  }

  static ContainSpecialChartsValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.SPECIALS).test(control.value)
      ? null
      : { needSpecialCharts: true };
  }
  static PasswordComplexityValidator(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value || '';
    if (!value) return null;

    const hasUpperCase = RegExp(PASSWORD_PATTERNS.UPPER_CASE).test(value);
    const hasLowerCase = RegExp(PASSWORD_PATTERNS.LOWER_CASE).test(value);
    const hasDigit = RegExp(PASSWORD_PATTERNS.DIGITS).test(value);
    const hasSpecialChar = RegExp(PASSWORD_PATTERNS.SPECIALS).test(value);

    const isValid = hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar;

    return isValid ? null : { passwordInvalid: true };
  }
  static DigitLeterSpaceValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.DIGITLETERSPACE_).test(control.value)
      ? null
      : { onlyDigLeterSpace: true };
  }

  static VINcodeValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.VIN_).test(control.value)
      ? null
      : { vinTemplateerror: true };
  }
  static MCDOTNumber(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.MCDOT).test(control.value)
      ? null
      : { mcdotNumberError: true };
  }
  static EmailValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === null || RegExp(PASSWORD_PATTERNS.EMAIL).test(control.value) ? null : { email: true };
  }

  static dateRange30DaysValidator(control: AbstractControl): ValidationErrors | null {
    const value: string[] = control.value;
    let period: number;
    if (value && value[0] && value[1]) {
      const minDate: Date = new Date(value[0]);
      const maxDate: Date = new Date(value[1]);
      period = (maxDate.getTime() - minDate.getTime()) / (1000 * 3600 * 24);
    }
    return control.value === null || period < 30 ? null : { date30DaysRange: true };
  }
}
